define('plugin/google-reviews/view/GoogleReviewsItemView',['require','lib/view/LayoutView'],function (require) {

    var LayoutView = require('lib/view/LayoutView');

    /**
     * Google Reviews item view
     *
     * @class GoogleReviewsItemView
     */
    return LayoutView.extend({
        template: '#google_reviews_item_view'
    });

});
